import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule } from '@angular/router';

import { AccountSetupRouteReuseStrategy } from './account-setup.route-reuse-strategy';
import { NotFoundComponent } from './not-found/not-found.component';
import { AccountSetupI18nResolver as TellentAccountSetupI18nResolver } from './shared-ts/account-setup-i18n-resolver.service';
import { AccountSetupI18nResolver } from './shared/account-setup-i18n-resolver.service';
import { AccountSetupSharedModule } from './shared/shared.module';

@NgModule({
  providers: [{ provide: RouteReuseStrategy, useClass: AccountSetupRouteReuseStrategy }],
  imports: [
    RouterModule.forRoot(
      [
        {
          path: ':lang',
          resolve: [TellentAccountSetupI18nResolver],
          children: [
            {
              path: ':token/org',
              loadChildren: () =>
                import('./company-ts/company.module').then(m => m.AccountSetupCompanyTSModule),
            },
            {
              path: ':token/user',
              loadChildren: () =>
                import('./user-ts/user.module').then(m => m.AccountSetupUserTSModule),
            },
            { path: '404', component: NotFoundComponent },
            { path: '**', redirectTo: '404', pathMatch: 'full' },
          ],
          canMatch: [
            () => checkBrandDomain('tellent') || checkBrandDomain('dynamic.s.recruitee.com'),
          ],
        },
        {
          path: ':lang',
          resolve: [AccountSetupI18nResolver],
          children: [
            {
              path: ':token/company',
              loadChildren: () =>
                import('./company/company.module').then(m => m.AccountSetupCompanyModule),
            },
            {
              path: ':token/user',
              loadChildren: () => import('./user/user.module').then(m => m.AccountSetupUserModule),
            },
            { path: '404', component: NotFoundComponent },
            { path: '**', redirectTo: '404', pathMatch: 'full' },
          ],
        },
        { path: '**', redirectTo: 'en/404', pathMatch: 'full' },
      ],
      {
        paramsInheritanceStrategy: 'always',
        enableTracing: false,
      },
    ),
    AccountSetupSharedModule,
  ],
  exports: [RouterModule],
})
export class AccountSetupRoutingModule {}

const checkBrandDomain = (domainName: string) => window.location.hostname.includes(domainName);
